var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from 'react';
import { defaultGroupProps } from './defaults';
function getCheckedValue(children) {
    var value = null;
    var matched = false;
    React.Children.forEach(children, function (radio) {
        if (radio && radio.props && radio.props.checked) {
            value = radio.props.value;
            matched = true;
        }
    });
    return matched ? { value: value } : undefined;
}
var RadioGroup = /** @class */ (function (_super) {
    __extends(RadioGroup, _super);
    function RadioGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.onRadioChange = function (value, e) {
            var lastValue = _this.state.value;
            if (!('value' in _this.props)) {
                _this.setState({
                    value: value,
                });
            }
            var onChange = _this.props.onChange;
            if (onChange && value !== lastValue) {
                onChange(value, e);
            }
        };
        var value;
        if ('value' in props) {
            value = props.value;
        }
        else if ('defaultValue' in props) {
            value = props.defaultValue;
        }
        else {
            var checkedValue = getCheckedValue(props.children);
            value = checkedValue && checkedValue.value;
        }
        _this.state = {
            value: value,
        };
        return _this;
    }
    RadioGroup.getDerivedStateFromProps = function (nextProps) {
        if ('value' in nextProps) {
            return {
                value: nextProps.value,
            };
        }
        var checkedValue = getCheckedValue(nextProps.children);
        if (checkedValue) {
            return {
                value: checkedValue.value,
            };
        }
        return null;
    };
    RadioGroup.prototype.render = function () {
        var _this = this;
        var value = this.state.value;
        var _a = this.props, style = _a.style, className = _a.className, onChange = _a.onChange, disabled = _a.disabled, rest = __rest(_a, ["style", "className", "onChange", "disabled"]);
        return (React.createElement("div", __assign({ name: RadioGroup.NAME, style: style, className: className }, rest), React.Children.map(this.props.children, function (element) {
            // if element is null or string
            if (!element || !element.type) {
                console.warn('RadioGroup Children is cannot be null or string');
                return null;
            }
            // const name = element.type.name
            // if (!name || (name !== 'Radio' && name !== 'RadioButton')) {
            //   console.warn('RadioGroup Children is only support Radio/RadioButton.')
            //   return null
            // }
            var childProps = __assign(__assign({}, element.props), { onRadioChange: _this.onRadioChange, key: element.props.value });
            if (disabled) {
                childProps = __assign(__assign({}, childProps), { disabled: disabled });
            }
            var checked = value === element.props.value;
            childProps = __assign(__assign({}, childProps), { checked: checked });
            return React.cloneElement(element, __assign(__assign({}, element.props), childProps));
        })));
    };
    RadioGroup.defaultProps = defaultGroupProps;
    RadioGroup.NAME = 'radio-group';
    RadioGroup.displayName = 'RadioGroup';
    return RadioGroup;
}(PureComponent));
export { RadioGroup };
